/**
 * Verknuepfte Termine eines Projekts oder einer Aufgabe (F-04 d) - rein.
 * Kommende zuerst aufsteigend, vergangene absteigend (die juengsten oben).
 */
import type { CalendarOccurrence, ID, LocalDateTime } from '@/domain/types';

export type TerminFilter = { projectId: ID } | { taskId: ID };

const endeAlsZeit = (o: CalendarOccurrence): string => (o.allDay ? `${String(o.end)}T00:00` : String(o.end));

export function gehoertZuFilter(o: CalendarOccurrence, f: TerminFilter): boolean {
  return 'projectId' in f ? o.projectId === f.projectId : Boolean(o.taskIds?.includes(f.taskId));
}

export function verknuepfteTermine(
  occurrences: CalendarOccurrence[], f: TerminFilter, jetzt: LocalDateTime,
): { kommend: CalendarOccurrence[]; vergangen: CalendarOccurrence[] } {
  const eigene = occurrences.filter((o) => gehoertZuFilter(o, f));
  return {
    kommend: eigene.filter((o) => endeAlsZeit(o) > jetzt).sort((a, b) => String(a.start).localeCompare(String(b.start))),
    vergangen: eigene.filter((o) => endeAlsZeit(o) <= jetzt).sort((a, b) => String(b.start).localeCompare(String(a.start))),
  };
}
